"use client";

import React from "react";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const metricsData = [{
  id: 1,
  displayValue: "12,400+",
  progressValue: 100,
  label: "Active Users",
  type: "progress"
}, {
  id: 2,
  displayValue: "850k+",
  progressValue: 0,
  label: "Leads Generated",
  type: "counter"
}, {
  id: 3,
  displayValue: "312%",
  progressValue: 100,
  label: "Revenue Growth",
  type: "progress"
}, {
  id: 4,
  displayValue: "4,200h",
  progressValue: 100,
  label: "Automation Hours",
  type: "progress"
}];
function MetricItem({
  metric,
  index
}: {
  metric: typeof metricsData[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div data-section-id="116246" ref={ref} data-index={index} className={`flex flex-col gap-4 transition-all duration-1000 ease-out border-[#2D7FF9]/20 lg:border-r last:border-r-0 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
    transitionDelay: `${index * 150}ms`
  }}>
      <div className="text-5xl md:text-6xl font-bold text-white tracking-tighter font-default">
        {metric.displayValue}
      </div>
      
      {metric.type === "progress" && <div className="w-full pt-2 pb-1">
          <Progress value={isVisible ? metric.progressValue : 0} className="h-1 bg-[#10B981]/20 animate-pulse" />
        </div>}
      
      <div className="text-[#94A3B8] font-medium text-lg md:text-xl mt-auto font-default">
        {metric.label}
      </div>
    </div>;
}
export default function PortalSuccessMetrics() {
  return <section id="growth-metrics" className="dark bg-[#161B22] text-foreground relative overflow-hidden py-24 md:py-32 px-4 sm:px-8 lg:px-16">
      {}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623996/img/designforge_logo_watermark_dark.png" alt="" className="w-[150%] md:w-[80%] max-w-none opacity-[0.03] mix-blend-overlay object-contain" aria-hidden="true" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {metricsData.map((metric, index) => <MetricItem key={metric.id} metric={metric} index={index} />)}
        </div>
      </div>
    </section>;
}